import React from 'react'
import { Outlet } from 'react-router-dom'

import {
  Box,
  CssBaseline,
  Toolbar,
  AppBar,
  IconButton,
  Container,
  Typography,
} from '@mui/material'

import AuthenticatedNavigation from '../AuthenticatedNavigation'
import StikisLogoTiny from 'images/stikis_logo-img_only-small.png'
import StaticFlash from '../static/StaticFlash'
import StaticFooter from '../static/StaticFooter'

const classes = {
  // Fills the space between the logo and the navigation links, which pushes
  // the links to the right of the bar (as PageMenu and NoPageMenu do).
  growBox: {
    display: 'flex',
    flexGrow: 1,
  },
}

export default function FormLayout() {

  return (
    <React.Fragment>
      <Box sx={
        { display: 'flex', position: 'relative', zIndex: 2}
      }>
        <CssBaseline />
        <AppBar position='relative'>
          <Toolbar>
            <IconButton
              href='/app/welcome'
              edge='start'
              aria-label='home page'
              sx={{
                paddingRight: '2px',
                color: 'white',
              }}
              size='large'
            >
              <img src={StikisLogoTiny} id='stikisLogoTiny' alt='Stikis logo' />
              <Typography
                variant='h1'
                sx={{
                  fontWeight: 900,
                  fontSize: '2rem',
                }}
              >
                stikis
              </Typography>
            </IconButton>
            <Box sx={classes.growBox}>
            </Box>
            <AuthenticatedNavigation />
          </Toolbar>
        </AppBar>
      </Box>
      <Container component="main" maxWidth="md">
        <StaticFlash />
        <Box
          sx={{
            marginTop: 9,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Outlet />
        </Box>
      </Container>
      <StaticFooter />
    </React.Fragment>
  )
}